export function RemoveButton({ onClick }: { onClick: () => void }) {
	return (
		<button
			type="button"
			onClick={onClick}
			aria-label="Remove from cart"
			title="Remove"
			className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-slate-500 transition hover:bg-rose-500/10 hover:text-rose-300"
		>
			×
		</button>
	);
}
